export const validateStringGenericEssential = (value: string | null) => {
	if (!value) return false;
	return typeof value === 'string' && value.length >= 3;
};

export const validateStringGeneric = (value: string | null) => {
	if (value === '') return true;
	if (!value) return true;
	return value.length >= 3;
};

export const validateStringGenericAny = (value: string | null) => {
	if (value === '') return true;
	if (!value) return true;
	return typeof value === 'string';
};

export const validateStringEmail = (value: string | null) => {
	if (!value) return false;
	const emailRegex = new RegExp(
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	);
	return validateStringGenericEssential(value) && emailRegex.test(value);
};

export const validateStringPesel = (value: string | null) => {
	if (!value) return false;
	return validateStringGenericEssential(value) && value.length === 11;
};

export const validateStringPhone = (value: string | null) => {
	if (!value) return false;
	return validateStringGenericEssential(value) && value.length === 9;
};

export const validateStringNip = (value: string | null) => {
	if (!value) return false;
	return validateStringGenericEssential(value) && value.length === 10;
};

export const validateStringPostal = (value: string | null) => {
	if (!value) return false;
	return (
		validateStringGenericEssential(value) &&
		value.length === 6 &&
		value.charAt(2) === '-'
	);
};

export const validateStringHouseNo = (value: string | null) => {
	if (!value) return false;
	return typeof value === 'string' && value.length > 0;
};
